var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artwork",attrs:{"aria-hidden":"true"}},[_c('div',{class:['ratio ratio-1-1', {dark: _vm.isDark}],style:(_vm.artworkStyle),attrs:{"aria-label":("Artwork for " + (_vm.epi.title))}})])}
var staticRenderFns = []

export { render, staticRenderFns }